module.exports = __webpack_public_path__ + "img/project1907.7472f163.png";